import React from "react";
import { Button } from "@heroui/react";

interface ConnectWalletSectionProps {
  onModalOpens: () => void;
  onModalCloses: () => void;
}

export function ConnectWalletSection({
  onModalOpens,
  onModalCloses,
}: ConnectWalletSectionProps) {
  const handleConnectWallet = (type: string) => {
    const event = new Event(type);
    dispatchEvent(event);
  };

  return (
    <div className="p-8 h-full flex flex-col">
      <h2 className="text-2xl font-bold text-white mb-2">Connect Wallet</h2>
      <p className="text-neutral-400 text-sm mb-8 border-b border-neutral-800 pb-4">
        Connect your MultiversX wallet to access the AiNexus Marketplace
      </p>

      <div className="flex flex-col space-y-3 gap-4 mb-auto">
        <Button
          variant="flat"
          className="bg-primary hover:bg-primary/90 text-white h-12 transition-all duration-200"
          onPress={() => handleConnectWallet("XPortalLogin")}
          radius="sm"
          disableRipple
        >
          xPortal App
        </Button>

        <Button
          variant="flat"
          className="bg-primary hover:bg-primary/90 text-white h-12 transition-all duration-200"
          onPress={() => handleConnectWallet("DefiWalletLogin")}
          radius="sm"
          disableRipple
        >
          DeFi Wallet
        </Button>

        <Button
          variant="flat"
          className="bg-primary hover:bg-primary/90 text-white h-12 transition-all duration-200"
          onPress={() => handleConnectWallet("WebWalletLogin")}
          radius="sm"
          disableRipple
        >
          Web Wallet
        </Button>

        <Button
          variant="flat"
          className="bg-primary hover:bg-primary/90 text-white h-12 transition-all duration-200"
          onPress={() => handleConnectWallet("LedgerLogin")}
          radius="sm"
          disableRipple
        >
          Ledger
        </Button>
      </div>

      <p className="text-xs text-neutral-500 mt-6 text-center pt-4 border-t border-neutral-800">
        By connecting, you agree to the terms of service and privacy policy
      </p>
    </div>
  );
}
